import { modalTypes } from "constants/types";
import { useDispatch, useSelector } from "react-redux";
import { showModal } from "slices/app/actions/modals";
import { selectOutlineOwner } from "slices/proposalOutline/selectors";

const useCombineDocuments = () => {
  const dispatch = useDispatch();
  const owner = useSelector(selectOutlineOwner);

  return () => {
    dispatch(showModal(modalTypes.COMBINE_OUTLINE_DOCS_MODAL, { owner }));
  };
};

export default useCombineDocuments;
